export enum ProcessType {
    Deployment = "Deployment",
    Runbook = "Runbook",
}
